
import { computed } from 'vue';

// icons
import { personCircle, compass, informationCircle, mail, call, location, } from 'ionicons/icons';

// components
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent,
        IonGrid, IonCol, IonRow, IonSpinner,
        IonCard, IonCardHeader, IonCardContent, IonCardTitle, IonCardSubtitle,
        IonSegment, IonSegmentButton, IonLabel, IonAvatar,
        IonButtons, IonButton, IonSlide, IonSlides, IonIcon, modalController, } from '@ionic/vue';
import ProductCard from "@/components/ProductCard.vue";
import CartButton from "@/components/CartButton.vue";
import LogoImg from "@/components/LogoImg.vue";
import CoachModal from '@/components/CoachModal.vue';

// services
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

import { utils } from '@/composables/utils';
import config from '@/config';

export default {
  name: 'HomePage',
  components: { IonPage, IonHeader, IonToolbar, IonTitle, IonContent,
                IonGrid, IonCol, IonRow, IonSpinner,
                IonCard, IonCardHeader, IonCardContent, IonCardTitle, IonCardSubtitle,
                IonSegment, IonSegmentButton, IonLabel, IonAvatar,
                IonButtons, IonButton, IonSlide, IonSlides, IonIcon,
                ProductCard, CartButton, LogoImg, },
  setup() {
    // methods
    const { t, locale } = useI18n();
    const store = useStore();
    const router = useRouter();
    const { openBrowser } = utils();

    // state variables
    const loadingProductCategories = computed(() => store.state.loadingProductCategories);
    const loadingProducts = computed(() => store.state.loadingProducts);
    //const banners = computed(() => store.state.homeBanners);
    const featuredProducts = computed(() => store.getters.featuredProducts);
    const latestProducts = computed(() => store.getters.latestProducts);
    const allProductCategories = computed(() => store.state.allProductCategories);
    const loadingCompanyInfo = computed(() => store.state.loadingCompanyInfo);
    const companyInfo = computed(() => store.state.companyInfo);
    const coaches = computed(() => store.state.coaches);
    const bannerSlideOpts = {
      slidesPerView: 1,
      autoHeight: true,
      initialSlide: 0,
      speed: config.HomePage.banner.slidingSpeed,
      loop: true,
      autoplay: {
        delay: config.HomePage.banner.autoPlayDelay,
      },
      breakpoints: {
        // when window width is >= 640px
        1024: {
          slidesPerView: config.HomePage.banner.desktopSlidesPerView,
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    };
    const tabSlideOps = {
      slidesPerView: 2,
      freeMode: true,
      autoHeight: true,
      loop: true,
      autoplay: true,
      spaceBetween: 0,
      breakpoints: {
        // when window width is >= 640px
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
        }
      }
    };
    const categorySegmentChanged = (e: any) => {
      router.replace({ name: 'ProductListPage', query: { category: e.target.value } }); // go to product page and pre-select category
    }
    const openCoachModal = async (coach: any) => {
      const modal = await modalController.create({
        component: CoachModal,
        componentProps: { coach },
      });
      return modal.present();

    }

    return {
      t,

      categorySegmentChanged, openBrowser, openCoachModal,

      // icons
      personCircle, compass, informationCircle, mail, call, location,
      
      // variables
      loadingCompanyInfo, companyInfo,
      bannerSlideOpts, tabSlideOps,
      loadingProducts, loadingProductCategories,
      featuredProducts, latestProducts,
      allProductCategories,
      locale,
      coaches,
    }
  },
}
